import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerLivros'; 
import AboutLivros from './AboutLivros';
import "../../styles/psicomotricidade.css"
import "../../styles/footer.css";

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutLivros />
      </div>
    );
  };
  
  export default About;